import React from 'react';
import { getConfiguration } from '../data/utils/configuration';
import { getStatsUrl } from '../data/utils/getStatsUrl';
// import Loader from './Loader';
import { getLabel } from '../data/labels';
import OverlayWrapper from './OverlayWrapper';
import PrematchProWidget from '../data/widgets/PrematchPro';
import { STATSCORE_WIDGET_PREMATCH_PRO, getStatsCoreConfigurationId } from '../data/widgets/WidgetContext';

export default function StatsOverlay(props) {
    const prematchProEnabled = getStatsCoreConfigurationId(STATSCORE_WIDGET_PREMATCH_PRO) != null;
    const conf = getConfiguration();

    return (
        <OverlayWrapper id="xs-stats-overlay">
            <div className="xs_statsOverlay z-50 absolute top-0 left-0 right-0 bottom-0 grid grid-rows-[48px_1fr] bg-cs1">
                <div className="z-20 border-b border-b-cs7 bg-cs1">
                    <div className="h-full grid grid-cols-12 items-center">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className={`col-start-3 col-end-${conf.iwh ? '10' : '13'} font-medium text-lg text-cs-3`}>{getLabel('navbar_buttons.stats')}</div>
                        {conf.iwh && <div className="col-start-10 col-end-12 justify-self-end inline-block" onClick={props.toggle}>
                            <i className="bi-close-lg font-medium text-lg text-cs-3"></i>
                        </div>}
                    </div>
                </div>
                <div className="relative">
                    {/* <Loader /> */}
                    {prematchProEnabled ?
                        <PrematchProWidget id={props.match.lsportWidgetId} />
                        :
                        <iframe title="xs-stats-iframe" className="absolute top-0 left-0 right-0 bottom-0" width="100%" height="100%" src={getStatsUrl(props.match.id)} />
                    }
                </div>
            </div>
        </OverlayWrapper>
    );
}
